const urls = {
  Outlets: {
    url: 'https://www.e-res.lancaster.ac.uk/DirectoryWebAPI/api/v2/Business',
    endpoints: {
      all: 'All'
    }
  }
};

export default urls;
